export default __webpack_public_path__ + "static/media/adresse-geographique.3f5a4409.svg";